<template>
    <div class="col-12">
        <div class="row">
            <b-overlay :show="loading" class="content">
                <div class="mb-3 text-center">
                    <hr />
                    <strong> تحلیل اقساط فروشگاه {{ shopName }}</strong>
                    <hr />
                </div>
                <div class="alert alert-warning">
                    <span>
                        به صورت پیش فرض تحلیل اقساط 6 ماه آخر نمایش داده میشود، در صورت نیاز
                        میتوانید با استفاده از دکمه <strong>تنظیمات صفحه</strong> بازه زمانی
                        مورد نظر خود را تعیین نمایید.
                    </span>
                </div>
                <div class="w-100 mb-3 float-left">
                    <button type="button"
                            class="btn btn-light text-right"
                            @click="showFilters = true">
                        <font-awesome-icon class="mr-2 ml-2" icon="sliders-h" /> تنظیمات صفحه
                    </button>
                    <button type="button"
                            class="btn btn-light text-right"
                            @click="getExport">
                        <font-awesome-icon class="mr-2 ml-2" icon="file-export" /> دریافت خروجی اکسل
                    </button>
                </div>
                <div class="table-responsive pb-2">
                    <table ref="tb" class="table table-bordered bg-white table-striped text-center"
                           style="font-size:13px;">
                        <thead>
                            <tr>
                                <th v-for="field in fields"
                                    v-if="field.showCell"
                                    :key="field.key">
                                    {{ $t("param." + field.key) }}
                                </th>
                                <th v-for="item in months">
                                    <span class="d-block">{{ item.name }}</span>
                                    <small>{{ item.year }}</small>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in items">
                                <td v-for="field in fields" v-if="field.showCell">
                                    <span v-if="field.key == 'record'">
                                        {{ index + 1 }}
                                    </span>
                                    <span v-else v-bind:class="{ 'card-number': field.cardNumber }">
                                        {{field.money ? new Intl.NumberFormat().format(item[field.key]) : item[field.key] }}
                                    </span>
                                </td>
                                <td v-for="monthItem in months">
                                    <span v-for="ts in item.transactionSplits"
                                          v-if="monthItem.year == ts.splitYear && monthItem.month == ts.splitMonth">
                                        {{ new Intl.NumberFormat().format(ts.totalSplitValue) }}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td v-bind:colspan="fields.filter(x => x.showCell == true).length">
                                    مجموع
                                </td>
                                <td v-for="monthItem in months">
                                    <span v-for="ts in transactionSplitDocs"
                                          v-if="monthItem.year == ts.splitYear && monthItem.month == ts.splitMonth">
                                        {{ new Intl.NumberFormat().format(ts.creditAmount) }}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td v-bind:colspan="fields.filter(x => x.showCell == true).length">
                                    واریزی شرکت
                                </td>
                                <td v-for="monthItem in months">
                                    <span v-for="ts in transactionSplitDocs"
                                          v-if="monthItem.year == ts.splitYear && monthItem.month == ts.splitMonth">
                                        {{ new Intl.NumberFormat().format(ts.debtAmount) }}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td v-bind:colspan="fields.filter(x => x.showCell == true).length">
                                    مغایرت
                                </td>
                                <td v-for="monthItem in months">
                                    <span v-for="ts in transactionSplitDocs"
                                          v-if="monthItem.year == ts.splitYear && monthItem.month == ts.splitMonth">
                                        {{ new Intl.NumberFormat().format(ts.leftAmount) }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-overlay>
        </div>
        <b-modal size="lg" hide-footer v-model="showFilters">
            <div class="col-12">
                <div class="row">
                    <div class="col-12 col-md-7 float-right">
                        <table class="table table-borderless text-right">
                            <tr>
                                <td>{{ $t("param.table.fromDate") }}</td>
                                <td>
                                    <date-picker color="#f5c842"
                                                 :auto-submit="true"
                                                 v-model="fromDate"
                                                 type="year-month"
                                                 min="1396/12/01"
                                                 max="1410/01/01" />
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t("param.table.toDate") }}</td>
                                <td>
                                    <date-picker color="#f5c842"
                                                 :auto-submit="true"
                                                 v-model="toDate"
                                                 type="year-month"
                                                 min="1396/12/01"
                                                 max="1410/01/01" />
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-12 col-md-5 float-right">
                        <table class="table text-right table-light">
                            <tr v-for="(field, index) in fields" v-if="field.shotDetails">
                                <th>{{ $t("param." + field.key) }}</th>
                                <td>
                                    <b-form-checkbox switch
                                                     v-model="fields[index].showCell"
                                                     size="lg"></b-form-checkbox>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <button class="btn btn-outline-dark" @click="initFilters">
                        اعمال تنظیمات
                    </button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>

    import XLSX from 'xlsx';

    export default {

        props: {
            shopId: 0
        },

        data()
        {
            return {
                loading: false,
                showFilters: false,
                showSplits: false,
                showDetails: false,
                transactionSplitDocs: [],
                shopName: '',
                selected: {},
                items: [],
                months: [],
                fields: [
                    {
                        key: "record",
                        showCell: true,
                        shotDetails: false
                    },
                    {
                        key: "transactionId",
                        showCell: false,
                        shotDetails: false
                    },
                    {
                        key: "transactionPersianDate",
                        showCell: true,
                        shotDetails: true
                    },
                    {
                        key: "transactionValue",
                        showCell: true,
                        shotDetails: true,
                        money: true
                    },
                    {
                        key: "splitCount",
                        showCell: true,
                        shotDetails: true
                    },
                    {
                        key: "cardHolderCardNumber",
                        showCell: false,
                        shotDetails: true,
                        cardNumber: true,
                        width: "100px;"
                    },
                    {
                        key: "clientTerminal",
                        showCell: false,
                        shotDetails: true
                    },
                    {
                        key: "shopName",
                        showCell: false,
                        shotDetails: true
                    },
                    {
                        key: "transactionTime",
                        showCell: false,
                        shotDetails: true
                    },
                    {
                        key: "shopAddress",
                        showCell: false,
                        shotDetails: true
                    }
                ],
                fromDate: null,
                toDate: null
            };
        },

        beforeMount()
        {
            this.initTable();
        },

        mounted()
        {
            this.totalRows = this.items.length;
        },

        methods: {

            getExport()
            {
                XLSX.writeFile(XLSX.utils.table_to_book(this.$refs.tb, { sheet: "Sheet1" }), 'export.xlsx');
            },

            initFilters()
            {
                this.showFilters = false;
                this.perPage = Number(this.perPageSelectedOption);
                this.initTable();
            },

            initTable()
            {
                this.loading = true;
                const data = {
                    FromDate: this.fromDate,
                    ToDate: this.toDate,
                    ShopID: this.shopId
                };

                axios({ method: "post", url: "/api/App/GetShopSplitAnalysis", data: data })
                    .then(response =>
                    {
                        this.transactionSplitDocs = response.data.meta.transactionSplitDocs;
                        this.items = response.data.meta.transactions;
                        this.months = response.data.meta.months;
                        this.shopName = response.data.meta.shopName;
                        this.loading = false;
                    })
                    .catch(error => { });
            },


            onShowDatails(item)
            {
                this.selected = item;
                this.showDetails = true;
            }
        }
    };
</script>
